import { API_BASE_URL as API_URL } from './config';

export const homeNewsAPI = {
  getCategories: async () => {
    const response = await fetch(`${API_URL}/home-newss/categories`);
    return response.json();
  },

  getHomepageNews: async (limit = 12) => {
    const response = await fetch(`${API_URL}/home-newss/homepage?limit=${limit}`);
    return response.json();
  },

  getNews: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.category) params.append('category', filters.category);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (typeof filters.isPublished !== 'undefined') {
      params.append('isPublished', String(filters.isPublished));
    }

    const response = await fetch(`${API_URL}/home-newss?${params.toString()}`);
    return response.json();
  },

  getNewsBySlug: async (slug) => {
    const response = await fetch(`${API_URL}/home-newss/slug/${slug}`);
    return response.json();
  },

  incrementView: async (id) => {
    const response = await fetch(`${API_URL}/home-newss/id/${id}/view`, {
      method: 'POST'
    });
    return response.json();
  },

  incrementShare: async (id) => {
    const response = await fetch(`${API_URL}/home-newss/id/${id}/share`, {
      method: 'POST'
    });
    return response.json();
  },

  getAdminNews: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.category) params.append('category', filters.category);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (typeof filters.isPublished !== 'undefined') {
      params.append('isPublished', String(filters.isPublished));
    }

    const response = await fetch(`${API_URL}/home-newss/admin/all?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.json();
  },

  addNews: async (payload) => {
    const response = await fetch(`${API_URL}/home-newss/admin/add`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      },
      body: payload
    });
    return response.json();
  },

  updateNews: async (id, payload) => {
    const response = await fetch(`${API_URL}/home-newss/admin/${id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      },
      body: payload
    });
    return response.json();
  },

  deleteNews: async (id) => {
    const response = await fetch(`${API_URL}/home-newss/admin/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.json();
  }
};

export default homeNewsAPI;
